import { object, string } from "yup";

export const NewEmployeePositionSchema = object({
  name: string().required("Задолжително"),
});
